export default  [
    {
        path: 'prioridade',
        redirect: 'prioridade/index',
        component: () => import(/* webpackChunkName: 'painel-senha-prioridade' */ '@/views/painel-senha/prioridade/Index'),
        children: [
            {
                name: 'painel-senha-prioridade-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'painel-senha-prioridade' */ '@/views/painel-senha/prioridade/List'),
            },
            {
                name: 'painel-senha-prioridade-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'painel-senha-prioridade' */ '@/views/painel-senha/prioridade/Form.vue'),
            },
        ],
    },
]